import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import {
  Grid,
  GridColumn,
  GridDetailRow,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { Popup } from "@progress/kendo-react-popup";
import * as React from "react";
import { toastr } from "react-redux-toastr";
import { NavLink } from "react-router-dom";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/RiskViews.scss";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import TaskTitle from "./TaskTitle";
import TaskStatus from "./TaskStatus";
import TaskOwner from "./TaskOwner";
import TaskAlertDescription from "./TaskAlertDescription";
import TaskAlertStakeholders from "./TaskAlertStakeholders";
import TaskDelayConsequence from "./TaskDelayConsequence";
import TaskProximityAlertDate from "./TaskProximityAlertDate";
import TaskActualCompDate from "./TaskActualCompDate";
import TaskProjectedComDate from "./TaskProjectedComDate";
import TaskOriginalCompDate from "./TaskOriginalCompDate";
import TaskPercentageCompletion from "./TaskPercentageCompletion";
import TaskPercentageOnTrack from "./TaskPercentageOnTrack";
import TaskEffort from "./TaskEffort";
import TaskCost from "./TaskCost";
import TaskDescription from "./TaskDescription";
import TaskApproved from "./TaskApproved";
import TaskActionRegisterFormView from "./TaskActionRegisterFormView";
import PriorityRank from "./PriorityRank";
import ColumnMenu from "../Dashboard/ColumnMenu";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
import ColumnMenuFilterForTask from "./ColumnMenuFilterForTask";
import moment from "moment";
import { mapTree } from "@progress/kendo-react-treelist";
import { formatNumber } from "@telerik/kendo-intl";
import { CustomFieldSearchMenuForAction } from "../Dashboard/CustomFieldSearchMenuForAction";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import TaskActivityProgressPopup from "./TaskActivityProgressPopup";

export class RecentlyViewedTasksActions extends GridDetailRow {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      editID: null,
      enterEditFlag: false,
      openDeleteModelFlagView: false,
      currentChangedValue: {},
      btnHideFlag: true,
      addActionbtnHideFlag: true,
      loader: false,
      formEditFlag: false,
      showFormView: false,
      formData: {},
      actionCompletionDatePopup: false,
      dataState: {
        sort: [
          {
            field: "code",
            dir: "asc",
          },
        ],
        take: 10,
        skip: 0,
      },
      updatedfield: 0,
      dropdownColumns: [],
      filter: {
        logic: "and",
        filters: [],
      },
      existingFilter: [],
      take: 10,
      skip: 0,
    };
    this.gridRef = React.createRef();
  }

  openActionCompletionDatePopup = () => {
    this.setState({ actionCompletionDatePopup: true });
  };
  closeActionCompletionDatePopup = () => {
    this.setState({ actionCompletionDatePopup: false });
    this.props.refreshTaskAction();
  };

  init = async (taskActions) => {
    // this.createDynamicDropdowns(this.props?.taskActionsList || []);
    this.setState({
      data: this.props?.taskActionsList || [],
      dataTemp: this.props?.taskActionsList || [],
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.taskActionsList !== prevProps.taskActionsList) {
      this.init();
    }
  }
  createDynamicDropdowns = async (products, filter) => {
    try {
      let dropdownColumn = [];
      products.map((res, i) => {
        res.customFields &&
          res.customFields.map((item, j) => {
            if (dropdownColumn.length > 0) {
              if (
                !dropdownColumn.find((cf) => cf.fieldName == item.fieldName)
              ) {
                dropdownColumn.push({
                  fieldName: item.fieldName,
                  data: this.getCustomFieldMasterData(item.fieldName, filter),
                  inputType: this.getInputType(item.fieldName),
                });
              }
            } else {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName, filter),
                inputType: this.getInputType(item.fieldName),
              });
            }
          });
      });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                let hashArr = this.stringToHashForCF(val, col.data);
                res[col.fieldName] = hashArr;
              } else if (temp.inputType === "Single Drop Down") {
                let val =
                  temp.selectedCustomFieldNames &&
                    temp.selectedCustomFieldNames.length > 0
                    ? temp.selectedCustomFieldNames.toString()
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? temp.multiText
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? parseInt(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val =
                  temp.multiText && temp.multiText != ""
                    ? new Date(temp.multiText)
                    : null;
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }

      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <GridColumn
            field={item.fieldName}
            title={item.fieldName}
            width={this.getFieldWidth(item.fieldName)}
            editable={false}
            resizable={true}
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
            columnMenu={(props) => this.getCustomFieldColumnMenu(props, item)}
            filter={this.getCustomFieldFilter(item)}
            headerClassName={
              this.checkItsinFilterOrNot(item.fieldName, filter) ? "active" : ""
            }
          />
        ));
      }

      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {
      console.log(err);
    }
  };
  checkItsinFilterOrNot = (field, exfilter) => {
    let headerClassName = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = true;
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {
      return headerClassName;
    }
  };
  getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };
  filterChangeExisting = async (e) => {
    if (e.nativeEvent.type == "submit") {
      let existingFilter = this.state.existingFilter
        ? this.state.existingFilter
        : [];
      let filter = e.filter ? e.filter.filters : [];

      // Get the field being filtered from the new filter
      const newFilterFields = new Set();
      if (filter && filter.length > 0) {
        filter.forEach(filterItem => {
          if (filterItem.filters) {
            filterItem.filters.forEach(innerFilter => {
              if (innerFilter.field) {
                newFilterFields.add(innerFilter.field);
              }
            });
          } else if (filterItem.field) {
            newFilterFields.add(filterItem.field);
          }
        });
      }

      // Remove any existing filters for the same fields
      let filteredExisting = existingFilter.filter(item => {
        // For filters with nested filters array
        if (item.filters) {
          return !item.filters.some(innerFilter =>
            innerFilter.field && newFilterFields.has(innerFilter.field)
          );
        }
        // For direct filters
        return !(item.field && newFilterFields.has(item.field));
      });

      // Combine filtered existing filters with new filters
      let combinedFilters = [...filteredExisting, ...filter];

      // Deduplicate the combined filters
      const uniqueFilters = new Set();
      const dedupedFilters = [];

      for (const filterItem of combinedFilters) {
        const filterStr = JSON.stringify(filterItem);
        if (!uniqueFilters.has(filterStr)) {
          uniqueFilters.add(filterStr);
          dedupedFilters.push(filterItem);
        }
      }
      const result = filterBy(this.state.dataTemp, dedupedFilters);
    // if (result && result.length > 0) {
      //   await this.createDynamicDropdowns(result, arr);
      // }
      var data = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        data: data,
        existingFilter: dedupedFilters,
        take: Math.round((window.innerHeight - 250) / 35),
        sort: [],
        filter: {
          logic: "and",
          filters: dedupedFilters,
        },
        skip: 0,
      });
    } else if (e.nativeEvent.type == "reset") {
      let exi = [];
      if (this.state.existingFilter) {
        let filterData = this.state.existingFilter;
        filterData.forEach((filter2) => {
          if (filter2.filters) {
            // Only add the filter if none of its inner filters match the selected column
            const hasMatchingInnerFilter = filter2.filters.some(
              innerFilter => innerFilter.field === this.state.selectedColumn
            );
            if (!hasMatchingInnerFilter) {
              exi.push(filter2);
            }
          } else {
            if (filter2.field != this.state.selectedColumn) {
              exi.push(filter2);
            }
          }
        });
      }
      const result = filterBy(this.state.dataTemp, exi);
      // await this.createDynamicDropdowns(result, exi);
      var data = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        data: data,
        existingFilter: exi,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: exi,
        },
      });
    }
  };
  filterChangeV = async (e, colname) => {
    try {
      let exi = []; // this.state.existingFilter;
      if (this.state.existingFilter) {
        let filterData = this.state.existingFilter;
        filterData.map((filter2) => {
          if (filter2.filters) {
            filter2.filters.map((innerFilter) => {
              if (innerFilter.field != colname) {
                exi.push(filter2);
              }
            });
          } else {
            if (filter2.field != colname) {
              exi.push(filter2);
            }
          }
        });
      }

      let filter = e ? e.filters : [];
      let temp = [];
      if (filter.length > 0) {
        temp = [
          {
            filters: filter,
            logic: "or",
          },
        ];
      }

      let arr = [...exi, ...temp];
      const result = filterBy(this.state.dataTemp, arr);
      //  if (result && result.length > 0) {
      //    await this.createDynamicDropdowns(result, arr);
      //  }
      var data = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        data: data,
        existingFilter: arr,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: arr,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };
  clearFilter = async (e) => {
    try {
      let filter = e ? e : [];
      const result = filterBy(this.state.dataTemp, filter);
      //  await this.createDynamicDropdowns(result, filter);
      var data = result.map((dataItem) =>
        Object.assign({ selected: false }, dataItem)
      );
      this.setState({
        ...this.state,
        data: data,
        existingFilter: filter,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter: {
          logic: "and",
          filters: filter,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };
  getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      return (
        <CustomFieldSearchMenuForAction
          {...props}
          customFieldsmaster={item.data}
          existingFilter={this.state.existingFilter}
          filterChangeV={this.filterChangeV}
          clearFilter={this.clearFilter}
        />
      );
    } else if (item.inputType === "Single Drop Down") {
      return (
        <ColumnMenuCheckboxFilter
          {...props}
          data={this.state.data}
          getSelectedColumn={this.getSelectedColumn}
        />
      );
    } else {
      return (
        <ColumnMenuFilterForTask
          {...props}
          getSelectedColumn={this.getSelectedColumn}
        />
      );
    }
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }
  getFieldWidth = (cellFieldName) => {
    let width = "200px";
    let res = this.props.persistenceActionGrid?.find(
      (item) => item.field === cellFieldName
    );
    if (res) {
      width = res.width;
    }
    return width;
  };
  getInputType = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster?.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.error(err);
    }
  };

  getCustomFieldMasterData = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster?.filter(
        (item) => item.fieldName == fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          temp.push({
            id: index,
            name: item.possibleValues,

            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue && originalValue.name != " [blank]") {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };
  itemChange = (event) => {
    let changedValue = { ...event.dataItem, [event.field]: event.value };
    const data = this.state.data || [];
    const dataValue = data.map((item) =>
      item.taskActionId === event.dataItem.taskActionId
        ? { ...item, [event.field]: event.value }
        : item
    );
    this.setState({
      ...this.state,
      currentChangedValue: changedValue,
      data: dataValue,
    });
    //dirty check
    let dirtData = data.find(
      (item) => changedValue.taskActionId == item.taskActionId
    );
    if (
      dirtData &&
      changedValue[this.state.editField] == dirtData[this.state.editField]
    ) {
      this.exitEdit();
      return;
    } else {
      if (event.field === "ownerName" && event.value) {
        let owner = this.props.ownerList.find(
          (item) => item.text === event.value
        );
        changedValue["ownerId"] = owner?.value;
      } else if (event.field === "priorityRankingName" && event.value) {
        let rank = this.props.priorityRankingsList.find(
          (item) => item.text === event.value
        );
        changedValue["priorityRankingId"] = rank?.value;
      }
      this.closeEditandSaveMitigation(changedValue);
    }
  };
  handleActulaCompletionDate = (date) => {
    let temp = this.state.currentChangedValue;
    temp["actualCompletionDate"] = date;
    this.setState({
      ...this.state,
      currentChangedValue: temp,
    });
  };
  closeEditandSaveMitigation = async (data) => {
    try {
      this.setState({ editID: null, enterEditFlag: false });
      if (!data.taskActionId) {
        return;
      }
      var mitigationReq = {};

      for (let field in data) {
        mitigationReq[field] = data[field];
      }
      await this.subTaskUpdate(mitigationReq);
    } catch (error) {
      console.error(error);
      this.setState({ loader: false });
    }
  };

  processInput = (input) => {
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  };
  updateTaskActionRegisterObject = (taskActionObj) => {
    console.log("taskActionObj", taskActionObj);
  };
  subTaskUpdate = async (taskObj) => {
    try {
      if (!taskObj.taskActionTitle || taskObj.taskActionTitle.trim() === "") {
        toastr.error("The Title field should not be empty.");
        return;
      }
      this.setState({ loader: true });
      taskObj.isClosed =
        taskObj.isClosed === "Closed" || taskObj.isClosed === true
          ? true
          : false;
      taskObj.isApproved =
        taskObj.isApproved === "Yes" || taskObj.isApproved === true
          ? true
          : false;
      if (taskObj.inEdit === "isClosed" &&
        taskObj.isClosed === true && !taskObj.actualCompletionDate) {
        this.setState({ loader: false });
        this.openActionCompletionDatePopup();
        return;
      }
      if (taskObj.inEdit === "percentageCompletion" && taskObj.percentageCompletion >= 100 && !taskObj.actualCompletionDate) {
        this.setState({ loader: false });
        this.openActionCompletionDatePopup();
        return;
      }
      if (
        taskObj.inEdit === "isClosed" &&
        taskObj.isClosed === false &&
        taskObj.percentageCompletion >= 100
      ) {
        taskObj.percentageCompletion = 0;
      }

      if (
        taskObj.inEdit === "isClosed" &&
        taskObj.isClosed === false &&
        taskObj.actualCompletionDate
      ) {
        taskObj.actualCompletionDate = null;
      }

      if (taskObj.percentageCompletion >= 100) {
        taskObj.isClosed = true;
        // taskObj.actualCompletionDate = new Date();
      }
      if (
        taskObj.percentageCompletion >= 100 &&
        !taskObj.actualCompletionDate
      ) {
        taskObj.isClosed = true;
        taskObj.actualCompletionDate = new Date();
      }

      if (taskObj.actualCompletionDate) {
        taskObj.isClosed = true;
      }

      if (taskObj.originalCompletionDate && !taskObj.projectedCompletionDate) {
        taskObj.projectedCompletionDate = taskObj.originalCompletionDate;
      }
      if (taskObj.projectedCompletionDate && !taskObj.originalCompletionDate) {
        taskObj.originalCompletionDate = taskObj.projectedCompletionDate;
      }
      if (taskObj.inEdit == "originalCompletionDate") {
        taskObj.projectedCompletionDate = taskObj.originalCompletionDate;
      }
      if (taskObj.isClosed === false) {
        taskObj.actualCompletionDate = null;
      }
      taskObj.alertStakeHolders = this.processInput(taskObj.alertStakeHolders);
      taskObj.proximityAlertDate = taskObj.proximityAlertDate
        ? moment(taskObj.proximityAlertDate).format("YYYY-MM-DD")
        : null;
      taskObj.originalCompletionDate = taskObj.originalCompletionDate
        ? moment(taskObj.originalCompletionDate).format("YYYY-MM-DD")
        : null;
      taskObj.projectedCompletionDate = taskObj.projectedCompletionDate
        ? moment(taskObj.projectedCompletionDate).format("YYYY-MM-DD")
        : null;
      taskObj.actualCompletionDate = taskObj.actualCompletionDate
        ? moment(taskObj.actualCompletionDate).format("YYYY-MM-DD")
        : null;
      let response = await Api.addTaskAction(taskObj);
      if (response.status === 200) {
        this.setState({ loader: false, updatedfield: taskObj.taskActionId });
        // this.props.refreshTaskAction();
        this.closeActionCompletionDatePopup()
      } else {
        toastr.error(response.message);
        this.setState({ loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ loader: false });
    }
  };

  addRecord = () => {
    this.setState({ ...this.state, showFormView: true });
  };

  cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];

    const additionalProps =
      cellField && cellField === inEditField
        ? {
          ref: (td) => {
            const input = td && td.querySelector("input");
            const activeElement = document.activeElement;

            if (
              !input ||
              !activeElement ||
              input === activeElement ||
              !activeElement.contains(input)
            ) {
              return;
            }

            if (input.type === "checkbox") {
              input.focus();
            } else {
              input.select();
            }
          },
        }
        : {
          onClick: () => {
            this.enterEdit(dataItem, cellField);
          },
          onFocus: () => {
            this.enterEdit(dataItem, cellField);
          },
          tabIndex: "0",
        };
    if (tdElement && tdElement.props) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps },
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  rowRender = (trElement, props) => {
    const taskActionId = this.state.updatedfield;

    const bgcolor = {
      backgroundColor: "rgba(0, 255, 76, 0.308)",
    };
    const trProps = {
      ...trElement.props,
      style: taskActionId == props.dataItem.taskActionId ? bgcolor : null,
      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        if (
          this.state.editField == "alertStakeHolders" ||
          this.state.editField === "progressComment"
        ) {
          return;
        }
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            this.exitEdit();
          });
        }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };

  enterEdit = (dataItem, field) => {
    const data = this.state.data || [];

    const dataValue = data.map((item) => ({
      ...item,
      inEdit: item.taskActionId === dataItem.taskActionId ? field : undefined,
    }));
    this.setState({
      data: dataValue,
      currentChangedValue: dataItem,
      editField: field,
    });
  };

  exitEdit = () => {
    const data = this.state.data || [];

    const dataValue = data.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    this.setState({
      data: dataValue,
    });
  };

  actionButtons = (event) => {
    let eventData = event.dataItem;
    return (
      <td className=" editBtns">
        {eventData.taskActionNumber ? (
          <ul className="actionIcon">
            <li>
              <a
                title="View"
                className="greenbtn"
                onClick={() => this.editFormView(eventData)}
              >
                <img src={Images.VIEW} width="12" alt="More" />
              </a>
            </li>
            <li>
              <a
                title="Documents"
                className={
                  eventData.documentCount == 0
                    ? "greenbtn roundedBtn icon"
                    : "bluebtn roundedBtn icon"
                }
              >
                <NavLink
                  title="Document"
                  className={
                    eventData.documentCount == 0
                      ? "greenbtn icon"
                      : "bluebtn icon"
                  }
                  to={`/${secureLocalStorage.getItem(
                    "loggedClient"
                  )}/${secureLocalStorage.getItem(
                    "tenantKey"
                  )}/home/documents/taskactiondocs/${eventData.taskActionId}`}
                >
                  <img
                    src={
                      eventData.documentCount == 0
                        ? Images.DOCUMENT
                        : Images.DOCUMENTBLUE
                    }
                    width="12"
                    alt="Document"
                  />
                </NavLink>
              </a>
            </li>
            <li>
              <a
                title="View"
                className="greenbtn"
                onClick={() => this.editFormView(eventData)}
              >
                <img src={Images.VIEW} width="12" alt="More" />
              </a>
            </li>
          </ul>
        ) : (
          ""
        )}
      </td>
    );
  };
  openDeletePopup = (data) => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: true,
      taskActionId: data.taskActionId,
    });
  };
  closeDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: false,
    });
  };

  deleteTaskAction = async () => {
    try {
      var requestParams = {
        taskActionId: this.state.taskActionId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteTaskAction(requestParams);
      if (response.status === 200) {
        toastr.success(response.message);
        this.props.refreshTaskAction();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };

  onColumnReorder = (event) => {
    try {
      let req = {
        persistenceDetails: JSON.stringify(event.target.columnResize.columns),
        WorkstreamId: null,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        screenName: "HomeTaskAction",
      };
      Api.addTaskPersistence(req);
    } catch (err) {
      console.log(err);
    }
  };
  mergeAndUpdateArrays = (array1, array2) => {
    // Create a Set of indexes present in array2
    const array2Values = new Set(array2.map((item) => item.field));

    // Loop through array1 and push missing items into array2
    array1.forEach((item) => {
      if (!array2Values.has(item.field)) {
        array2.push(item);
      }
    });

    // Sort array2 by index
    array2.sort((a, b) => a.orderIndex - b.orderIndex);
    return array2;
  };
  onColumnResize = (event) => {
    if (event.end) {
      try {
        let req = {
          persistenceDetails: JSON.stringify(event.target.columnResize.columns),
          WorkstreamId: null,
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
          screenName: "HomeTaskAction",
        };
        Api.addTaskPersistence(req);
      } catch (err) {
        console.log(err);
      }
    }
  };

  getReductionTitle = (temp) => {
    try {
      if (this.props.dataItem.isOpportunity === "Opportunity") {
        return "Increase in Probability (%)";
      } else {
        return "Reduction in Probability  (%)";
      }
    } catch (err) {
      return "Probability";
    }
  };

  getSelectedColumn = (col) => {
    if (col != this.state.selectedColumn) {
      this.setState({ ...this.state, selectedColumn: col });
    }
  };

  setClassName = (field) => {
    let headerClassName = "";
    if (this.state.filter && this.state.filter.filters) {
      this.state.filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };
  getGridColum = (columns) => {
    let field = columns.field;
    let title = columns.title;
    let width = columns.width;
    let currency = secureLocalStorage.getItem("currency");
    let effortUnitName = "Days";

    if (!field) {
      return;
    } else if (field === "taskActionNumber") {
      return (
        <GridColumn
          field={field}
          title="Activity Number"
          width="130px"
          resizable={false}
          editable={false}
          orderIndex={0}
          locked={true}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={`${this.setClassName("taskActionNumber")} no-drag`}
        />
      );
    }  else if (field === "taskActionTitle") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          locked={true}
          orderIndex={0}
          resizable={false}
          editable={true}
          cell={(props) => (
            <TaskTitle
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
              pageName={"home-activity"}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={`${this.setClassName("taskActionTitle")} no-drag`}
        />
      );
    } else if (field === "isApproved") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskApproved
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("isApproved")}
        />
      );
    } else if (field === "taskActionDescription") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDescription
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("taskActionDescription")}
        />
      );
    } else if (field === "cost") {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(currency) ? title : title + " (" + currency + ")"
          }
          width={width}
          resizable={true}
          editable={true}
          filter={"numeric"}
          cell={(props) => (
            <TaskCost
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("cost")}
        />
      );
    } else if (field === "effort") {
      return (
        <GridColumn
          field={field}
          title={
            title.includes(effortUnitName)
              ? title
              : title + " (" + effortUnitName + ")"
          }
          width={width}
          resizable={true}
          filter={"numeric"}
          editable={true}
          cell={(props) => (
            <TaskEffort
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("effort")}
        />
      );
    } else if (field === "priorityRankingName") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <PriorityRank
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
              priorityRankingsList={this.props.priorityRankingsList}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("priorityRankingName")}
        />
      );
    } else if (field === "priorityScore") {
      return (
        <GridColumn
          field={field}
          title={title}
          filter={"numeric"}
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("priorityScore")}
        />
      );
    } else if (field === "percentageOnTrack") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          filter={"numeric"}
          cell={(props) => (
            <TaskPercentageOnTrack
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("percentageOnTrack")}
        />
      );
    } else if (field === "percentageCompletion") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          filter={"numeric"}
          cell={(props) => (
            <TaskPercentageCompletion
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("percentageCompletion")}
        />
      );
    } else if (field === "originalCompletionDate") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          filter={"date"}
          cell={(props) => (
            <TaskOriginalCompDate
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("originalCompletionDate")}
        />
      );
    } else if (field === "projectedCompletionDate") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          filter={"date"}
          cell={(props) => (
            <TaskProjectedComDate
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("projectedCompletionDate")}
        />
      );
    } else if (field === "actualCompletionDate") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          filter={"date"}
          cell={(props) => (
            <TaskActualCompDate
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("actualCompletionDate")}
        />
      );
    } else if (field === "proximityAlertDate") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          filter={"date"}
          cell={(props) => (
            <TaskProximityAlertDate
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("proximityAlertDate")}
        />
      );
    } else if (field === "delayConsequence") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDelayConsequence
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("delayConsequence")}
        />
      );
    } else if (field === "alertStakeHolders") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(propstask) => (
            <TaskAlertStakeholders
              {...propstask}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.closeEditandSaveMitigation}
              exitEdit={this.exitEdit}
              dropDownData={
                this.props.stackeHolderList ? this.props.stackeHolderList : []
              }
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("alertStakeHolders")}
        />
      );
    } else if (field === "alertDescription") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskAlertDescription
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("alertDescription")}
        />
      );
    } else if (field === "ownerName") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskOwner
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
              ownerList={this.props.ownerList}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("ownerName")}
        />
      );
    } else if (field === "createdDate") {
      return (
        <GridColumn
          field="createdDate"
          title="created Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("createdDate")}
        />
      );
    } else if (field === "createdByName") {
      return (
        <GridColumn
          field="createdByName"
          title="Created By"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("createdByName")}
        />
      );
    } else if (field === "updatedDate") {
      return (
        <GridColumn
          field="updatedDate"
          title="updated Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("updatedDate")}
        />
      );
    } else if (field === "updatedByName") {
      return (
        <GridColumn
          field="updatedByName"
          title="Updated By"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("updatedByName")}
        />
      );
    } else if (field === "closedDate") {
      return (
        <GridColumn
          field="closedDate"
          title="Closed Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("closedDate")}
        />
      );
    } else if (field === "isClosed") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskStatus
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={this.state.data}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("isClosed")}
        />
      );
    } else if (field === "progressComment") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskActivityProgressPopup
              {...props}
              onEditCell={this.enterEdit}
              exitEdit={this.exitEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("progressComment")}
        />
      );
    } else if (field === "departments") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("departments")}
          cell={(props) => (
            <TaskDelayConsequence
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
        />
      );
    } else if (field === "externalStatus") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDelayConsequence
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("externalStatus")}
        />
      );
    } else if (field === "weeklyReport") {
      return (
        <GridColumn
          field={field}
          title={title}
          width={width}
          resizable={true}
          editable={true}
          cell={(props) => (
            <TaskDelayConsequence
              {...props}
              onEditCell={this.enterEdit}
              updateDropdownValue={this.updateTaskActionRegisterObject}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilterForTask
              {...props}
              getSelectedColumn={this.getSelectedColumn}
            />
          )}
          headerClassName={this.setClassName("weeklyReport")}
        />
      );
    } else if (field === "customFields") {
      return this.state.dropdownColumns;
    } else {
      let cf = this.state.dropdownColumns.find(
        (item) => field === item.props.field
      );
      if (cf) {
        return cf;
      }
    }
  };

  notavailable = () => {
    return (
      <td className="k-grid-content-sticky editBtns">
        <ul className="actionIcon">
          <span>NA</span>
        </ul>
      </td>
    );
  };

  closeRiskFormView = (flag) => {
    this.setState({
      ...this.state,
      showFormView: false,
      formData: {},
      formEditFlag: false,
    });
    if (flag == "REFRESH") {
      this.props.refreshTaskAction();
    }
  };
  addRiskDataFromForm = () => {
    this.props.refreshTaskAction();
  };
  editFormView = (dataItem) => {
    try {
      let orgUnit = {};
      mapTree(this.props.organisationUnitList, "children", (item) => {
        if (item.unitId === dataItem.organizationUnitId) {
          orgUnit = item;
        }
        return item;
      });
      this.setState({
        ...this.state,
        showFormView: true,
        formData: dataItem,
        formEditFlag: true,
        orgUnit: orgUnit,
      });
    } catch (err) {
      console.error(err);
    }
  };
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };
  sortChange = (event) => {
    this.setState({
      data: this.getProducts(event.sort),
      sort: event.sort,
    });
  };
  getProducts = (sort) => {
    return orderBy(this.state.data, sort);
  };
  render() {
    const data = this.state.data || [];
    return (
      <div id="home-riskMitigation">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        {this.state.showFormView === true ? (
          <TaskActionRegisterFormView
            formEditFlag={this.state.formEditFlag}
            formData={this.state.formData}
            showFormView={this.state.showFormView}
            orgUnit={this.state.orgUnit}
            closeRiskFormView={this.closeRiskFormView}
            addRiskDataFromForm={this.addRiskDataFromForm}
            dropDownData={
              this.props.stackeHolderList ? this.props.stackeHolderList : []
            }
            ownerListForRisk={this.props.ownerList ? this.props.ownerList : []}
            priorityRankingsList={this.props.priorityRankingsList}
            taskDetails={this.state.formData}
            role={this.state.formData?.role}
            {...this.props}
          />
        ) : (
          ""
        )}

        <Grid
          ref={this.gridRef}
          // data={this.state.data || []}
          data={filterBy(this.state.data, this.state.filter).slice(
            this.state.skip,
            this.state.take + this.state.skip
          )}
          {...this.state.dataState}
          onDataStateChange={(e) => {
            this.setState({ dataState: e.dataState });
          }}
          cellRender={this.cellRender}
          rowRender={this.rowRender}
          reorderable={data.length == 0 ? false : true}
          resizable={data.length == 0 ? false : true}
          editField="inEdit"
          onItemChange={this.itemChange}
          sortable={{
            allowUnsort: true,
            mode: "multiple",
          }}
          sort={this.state.sort}
          pageable={true}
          onSortChange={this.sortChange}
          total={filterBy(this.state.data, this.state.filter).length}
          skip={this.state.skip}
          take={this.state.take}
          onPageChange={this.pageChange}
          onColumnReorder={this.onColumnReorder}
          onColumnResize={this.onColumnResize}
          onFilterChange={this.filterChangeExisting}
          filter={this.state.filter}
        >
          <GridColumn
            cell={this.actionButtons}
            width="65px"
            filterable={false}
            orderIndex={0}
            resizable={false}
            reorderable={false}
            headerClassName="no-drag"
          />
          <GridColumn
            field="organizationUnitName"
            title="Workstream"
            width="180px"
            editable={false}
            minResizableWidth={100}
            locked={true}
            reorderable={false}
            resizable={false}
            orderIndex={0}
            columnMenu={ColumnMenu}
            headerClassName={`${this.setClassName("organizationUnitName")} no-drag`}
          />
          <GridColumn
            field="taskTitle"
            title="Task Title"
            width="200px"
            editable={false}
            minResizableWidth={100}
            locked={true}
            reorderable={false}
            orderIndex={0}
            resizable={false}
            columnMenu={ColumnMenu}
            headerClassName={`${this.setClassName("taskTitle")} no-drag`}
          />
          {this.props.persistenceTaskActionGrid.map((columns) =>
            this.getGridColum(columns)
          )}
        </Grid>

        <Popup
          show={this.state.openDeleteModelFlagView}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this Activity action?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.deleteTaskAction()}
                className="deleteBtn"
                type="button"
              >
                Delete
              </button>
              <button
                onClick={this.closeDeletePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
        <Popup
          show={this.state.actionCompletionDatePopup}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont actualCompPopup">
            <h3>Activity Update</h3>
            <div className="labelBlock">
              <label className="fieldLabel1">
                <span className="fieldTitle">Activity Title :</span>
                {this.state.currentChangedValue?.taskActionTitle}
              </label>

              <label className="fieldLabel2">
                <span className="fieldTitle">Activity Number : </span>
                {this.state.currentChangedValue?.taskActionNumber}
              </label>
            </div>
            <label className="fieldLabel3">
              <span className="fieldTitle">Actual Completion Date</span>
            </label>

            <DatePicker
              format="dd-MMM-yyyy"
              onChange={(e) => this.handleActulaCompletionDate(e.target.value)}
            />

            <div className="btnCont">
              <button
                onClick={() =>
                  this.closeEditandSaveMitigation(
                    this.state.currentChangedValue
                  )
                }
                type="button"
                className="deleteBtn"
              >
                Submit
              </button>
              <button
                onClick={this.closeActionCompletionDatePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
